/**
 * Login Page Component
 * 
 * Authentication page for the admin dashboard.
 * Users enter their credentials and receive a JWT token
 * that is stored in sessionStorage for subsequent API requests.
 */
import React from 'react';
import { Form, Input, Button, message } from 'antd';
import { useNavigate } from 'react-router-dom';
import { login } from '../../services/api';

const LoginPage = () => {
  const navigate = useNavigate();

  /**
   * Handles login form submission.
   * On success, stores JWT token and redirects to home page.
   * @param {Object} values - Form values (username, password)
   */
  const handleSubmit = async (values) => {
    try {
      const response = await login({
        login: values.username,
        password: values.password,
      });

      // Store JWT token in sessionStorage
      const { token } = response.data;
      sessionStorage.setItem('jwtToken', token);
      
      message.success('Login successful!');
      navigate('/');
    } catch (error) {
      const errorMessage =
        error.response?.data?.message || 'An error occurred during login';
      message.error(errorMessage);
    }
  };

  return (
    <div style={{ maxWidth: '400px', margin: '50px auto' }}>
      <h2>Login</h2>
      <Form layout="vertical" onFinish={handleSubmit}>
        <Form.Item
          name="username"
          label="Username"
          rules={[{ required: true, message: 'Please enter your username' }]}
        >
          <Input placeholder="Enter your username" />
        </Form.Item>
        <Form.Item
          name="password"
          label="Password"
          rules={[{ required: true, message: 'Please enter your password' }]}
        >
          <Input.Password placeholder="Enter your password" />
        </Form.Item>
        <Button type="primary" htmlType="submit" block>
          Login
        </Button>
      </Form>
    </div>
  );
};

export default LoginPage;
